/**
 * Phone-OTP and guest-checkout users get a synthetic Clerk email so the
 * Clerk user object has a primary identifier — but it's an internal
 * placeholder, never a user-typed address. This helper centralises the
 * "should we show this email?" decision so every profile/header/sidebar
 * surface treats them consistently.
 *
 * Two synthetic suffixes exist:
 *  - @users.hopp.co.in — Clerk-backed phone-OTP users (current format)
 *  - @phone.hopp.co.in — older soft-account tag (kept for backward
 *    compat; pre-dates the @users.hopp.co.in switch)
 */
export function isSyntheticEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return (
    email.endsWith("@users.hopp.co.in") ||
    email.endsWith("@phone.hopp.co.in")
  );
}

/**
 * Returns the email if it's safe to display, or null if it's a synthetic
 * placeholder that should be hidden from the user.
 */
export function displayEmailOrNull(
  email: string | null | undefined,
): string | null {
  if (!email) return null;
  if (isSyntheticEmail(email)) return null;
  return email;
}
